module.exports = __webpack_public_path__ + "img/kma_gallery17.34556aaf.jpg";